module.exports = __webpack_public_path__ + "img/emptystate-participants.70cfed6a.svg";